<wsd-extended-card
  [loading]="!(annualReporting$ | async)"
  [title]="'DATA_PORTAL.ANNUAL_REPORTING.TITLE' | translate">


  <div *ngIf="annualReporting$ | async as data">

    <div class="text-center m-t-5">
      <span class="numbers primary-color">
        {{ data.annualReport?.count + '/' + data.annualReport?.total  }}
      </span>
      <p class="mt-5">{{'DATA_PORTAL.ANNUAL_REPORTING.ANNUAL_REPORT' | translate}}</p>
    </div>

    <div class="text-center m-t-15">
      <span class="numbers primary-color">
        {{ data.financialReport?.count + '/' + data.financialReport?.total  }}
      </span>
      <p class="mt-5">{{'DATA_PORTAL.ANNUAL_REPORTING.ANNUAL_FINANCIAL_STATEMENT' | translate}}</p>
    </div>

  </div>
</wsd-extended-card>
